import { mapGetters } from 'vuex'

import { categoryOptions, timeRangesOptions } from '../utils/constants'
import { getTranslatedOptions } from '../utils/behavior'

export default {
  data() {
    return {
      getTranslatedOptions,
      categoryOptions,
      timeRangesOptions
    }
  },
  computed: {
    ...mapGetters({
      schools: 'getSchoolsOptions',
      isAdminUser: 'isAdminUser'
    })
  },
  methods: {
    updateFilter(field, value) {
      this.filters[field] = value
      this.updateChart()
    }
  }
}
